/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetChannelFilterListRequest,
  PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetChannelFilterListResponse,
  PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetOffendersRequest,
  PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetOffendersResponse,
  PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsCsvRequest,
  PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsRequest,
  PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsResponse,
  PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesCsvRequest,
  PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesRequest,
  PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesResponse,
  PiracyCommonProtocolFileResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class PerformanceDetailsOffenderPiracy<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags PerformanceDetailsOffenderPiracy
   * @name PiracyOffenderCreate
   * @request POST:/performance/piracy/offender
   */
  piracyOffenderCreate = (
    data: PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetOffendersRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetOffendersResponse, any>({
      path: `/performance/piracy/offender`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsOffenderPiracy
   * @name PiracyOffenderTopInfringingProfilesCreate
   * @request POST:/performance/piracy/offender/top-infringing-profiles
   */
  piracyOffenderTopInfringingProfilesCreate = (
    data: PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesResponse, any>({
      path: `/performance/piracy/offender/top-infringing-profiles`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsOffenderPiracy
   * @name PiracyOffenderTopInfringingDomainsCreate
   * @request POST:/performance/piracy/offender/top-infringing-domains
   */
  piracyOffenderTopInfringingDomainsCreate = (
    data: PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsResponse, any>({
      path: `/performance/piracy/offender/top-infringing-domains`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsOffenderPiracy
   * @name PiracyOffenderChannelFilterCreate
   * @request POST:/performance/piracy/offender/channel-filter
   */
  piracyOffenderChannelFilterCreate = (
    data: PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetChannelFilterListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetChannelFilterListResponse, any>({
      path: `/performance/piracy/offender/channel-filter`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsOffenderPiracy
   * @name PiracyOffenderTopInfringingProfilesCsvCreate
   * @request POST:/performance/piracy/offender/top-infringing-profiles/csv
   */
  piracyOffenderTopInfringingProfilesCsvCreate = (
    data: PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingProfilesCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PiracyCommonProtocolFileResponse, any>({
      path: `/performance/piracy/offender/top-infringing-profiles/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsOffenderPiracy
   * @name PiracyOffenderTopInfringingDomainsCsvCreate
   * @request POST:/performance/piracy/offender/top-infringing-domains/csv
   */
  piracyOffenderTopInfringingDomainsCsvCreate = (
    data: PerfPiracyDetailPerfDetailsOffenderPiracyProtocolsGetTopInfringingDomainsCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PiracyCommonProtocolFileResponse, any>({
      path: `/performance/piracy/offender/top-infringing-domains/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
